AddToRFP = (function (window, $j) {

    function onDocReady() {
        $j(".add-to-myrfp-button").click(function() {
            var id = $j(this).attr('data-location-id')
                    || $j(this).closest(".hotel-item").attr("data-location-id")
                    || false;
            addtoRFP(id);
        });
    }

    function addtoRFP(hotelId) {

        var id;
        var fromattr = $j(this).attr('data-location-id');

        if (hotelId) {
            id = hotelId;
        } else {
            id = $j(this).closest(".hotel-item").attr("data-location-id");
        }

        if (getCookie("OmniRFPIDs") === "") {
            setCookie("OmniRFPIDs", id, 30);
        }
        else {
            if(!isSaved(id)) {
                setCookie("OmniRFPIDs", getCookie("OmniRFPIDs") + "," + id, 30);
            }
        }

        console.log(getCookie("OmniRFPIDs"));
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; path=/; " + expires;
    }

    function clearRFPCookie() {
        document.cookie = "OmniRFPIDs=;" + "Expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    }

    // Used for updating the list after an item is removed on the RFP hotel selector
    function replaceCookie (ids) {
        ids.toString();
        setCookie("OmniRFPIDs", ids, 30);
    }

    function isSaved(id) {
        var cookieArray = getCookie("OmniRFPIDs").split(",");

        if (cookieArray.indexOf(id) === -1) {
            return false;
        }

        return true;
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    $j(onDocReady);

    return {
        addtoRFP: addtoRFP,
        clearRFPCookie: clearRFPCookie,
        isSaved: isSaved,
        replaceCookie: replaceCookie
    };

})(window, $j);
